import * as React from 'react';

const Trash = ({
  fill = 'none',
  width = '14',
  height = '19'
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 19"
    xmlns="http://www.w3.org/2000/svg">
    <g
      id="Screens"
      stroke="none"
      strokeWidth="1"
      fill={fill}
      fillRule="evenodd">
      <g
        id="B---01-Work-Station---01-Work-Station"
        transform="translate(-1244 -330)">
        <g id="Item-1" transform="translate(135 323)">
          <g id="Headline">
            <g id="trash" transform="translate(1104 4)">
              <path id="Base" d="M0 0h24v24H0z" />
              <path
                d="M18 8v12.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20.5V8h12zm-5-5a1 1 0 0 1 1 1v.5h4.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5H10V4a1 1 0 0 1 1-1z"
                fill="#4a4f4a"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Trash;
